import React, { useEffect, useState } from "react";
import axiosInstance from "../../../../axios";
import { getPaginatedData } from "../../../../_helpers";
import { Loading } from "../../../Other/Loading";
import Pagination from "./Pagination";
const { REACT_APP_PAYMENT_API_BASEURL } = process.env;
const CourseReport = () => {
  const [courseData, setCourseData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const { data, startIndex, totalPageCount } = getPaginatedData(
    courseData,
    currentPage
  );

  useEffect(() => {
    const fetchReportData = () => {
      axiosInstance
        .get(`${REACT_APP_PAYMENT_API_BASEURL}/v2/course-report`)
        .then((res) => {
          setCourseData(res?.data?.data);
        })
        .catch((error) => {
          console.log(error);
        });
    };
    fetchReportData();
  }, []);

  return (
    <div className="width-0">
      <div className="dashboard-container-new">
        <p>Detail Report For Courses</p>
        <div>
          <button className="lastmonth-btn">Last Month</button>
          <button className="export-btn">Export</button>
        </div>
      </div>

      <div className="page-data-new">
        {data?.length > 0 ? (
          <p className="showing-result">
            Showing page {currentPage} of {totalPageCount} results
          </p>
        ) : (
          <p className="showing-result">Showing 0 result</p>
        )}
      </div>

      <div className="instructor-table">
        {!data?.length ? (
          <Loading />
        ) : (
          <table className="table-width-100">
            <thead>
              <tr>
                <th>S.no</th>
                <th>Course Id</th>
                <th>Course Name</th>
                <th>Category</th>
                <th>EnrollmentFee</th>
                <th>Language</th>
                <th>courseViews</th>
                <th>Sold</th>
                <th>BundleSale</th>
              </tr>
            </thead>
            <tbody>
              {data?.map((ele, index) => {
                return (
                  <tr key={index}>
                    <td className="cell">
                      {currentPage * 10 - 10 + index + 1}
                    </td>
                    <td className="cell">{ele?.CourseID}</td>
                    <td className="cell">{ele?.CourseName}</td>
                    <td className="cell">
                      {ele?.Category === null ? "-" : ele?.Category}
                    </td>
                    <td className="cell">{ele?.EnrollmentFee}</td>
                    <td className="cell">{ele?.Language}</td>
                    <td className="cell">{ele?.courseViews}</td>
                    <td className="cell">{ele?.Sold}</td>
                    <td className="cell">{ele?.BundleSale}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
      <div className="pageNumbers-sudents">
        {/* <Pagination
          className="pageNumbers-sudents"
          currentPage={currentPage}
          totalCount={10}
          pageSize={totalPageCount}
          onPageChange={(page) => setCurrentPage(page)}
        /> */}
      </div>
    </div>
  );
};

export default CourseReport;
